
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import CacheManager from '@/shared/utils/cacheManager'

export default {
  name: 'TheNavbar',
  setup() {
    const store = useStore()
    const router = useRouter()
    const defaultAvatar = require('@/assets/default-avatar.svg')
    
    const isLoggedIn = computed(() => store.getters.isLoggedIn)
    const currentUser = computed(() => store.getters.currentUser)
    
    const handleLogout = async () => {
      await CacheManager.clearAllCache()
      await store.dispatch('logout')
      router.push('/')
    }

    const mobileMenuOpen = ref(false)

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }

    const closeMobileMenu = () => {
      mobileMenuOpen.value = false
    }

    return {
      isLoggedIn,
      currentUser,
      defaultAvatar,
      handleLogout,
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
    }
  }
}
